import { Skeleton } from '@/components/ui/skeleton';

import Container from './container';

export default function HeaderDashboardSkeleton() {
  return (
    <header
      className='sticky top-0 z-50 flex h-dashboard-navbar-height-mobile items-center bg-white shadow-sm md:h-dashboard-navbar-height'
      role='banner'
    >
      <Container className='relative flex items-center justify-between gap-4 py-2'>
        {/* Logo skeleton */}
        <Skeleton className='h-8 w-24' />

        {/* Desktop Navbar */}
        <nav
          className='hidden w-full items-center gap-2 md:flex'
          aria-label='Main navigation'
        >
          {/* Search section skeleton */}
          <div className='flex flex-1 items-center justify-center'>
            <Skeleton className='h-10 w-96 max-w-lg' />
          </div>

          {/* Action buttons skeleton */}
          <div
            className='flex items-center gap-3'
            role='group'
            aria-label='User actions'
          >
            <Skeleton className='size-10' />
            <Skeleton className='size-10' />
            <Skeleton className='size-10' />
            <Skeleton className='size-10 rounded-full' />
          </div>
        </nav>

        {/* Mobile Navbar */}
        <nav
          className='flex items-center gap-2 md:hidden'
          aria-label='Mobile navigation'
        >
          <Skeleton className='size-10' />
          <Skeleton className='size-10' />
          <Skeleton className='size-10' />
        </nav>
      </Container>
    </header>
  );
}
